import { render } from "./activityReport.vue?vue&type=template&id=b844b65a"
import script from "./activityReport.vue?vue&type=script&lang=js"
export * from "./activityReport.vue?vue&type=script&lang=js"

import "./activityReport.vue?vue&type=style&index=0&id=b844b65a&lang=scss"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__